import styled from 'styled-components'

const FormContentContainer = styled.div`
  margin-left: 8px;
`

export default FormContentContainer
